import { RiCalendarEventFill } from '@remixicon/react';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { usePicksContext } from '../../contexts/Picks/PicksContext';
import { verifyDatePick } from '../../helpers/utils';
import { FeedPickProps } from '../../types/pickFeed';
import TooltipGames from '../Tooltip/tooltipGames';

interface iProps {
	loading: boolean;
	data: FeedPickProps[];
	filters: any;
	setFilters: (filters: any) => void;
}

export const FilterTournamentGroup = ({
	data,
	loading,
	filters,
	setFilters,
}: iProps) => {
	const { SetTournamentGroup } = usePicksContext();

	useEffect(() => {
		if (data && data.length > 0) {
			SetTournamentGroup(data[0]);
		}
	}, [data]);

	return (
		<div className="flex px-3 pb-1 pt-3 flex-row gap-3">
			{loading ? (
				<div>
					<Skeleton className="w-full h-[543px] rounded-lg" />
				</div>
			) : (
				data &&
				data.map((item) => {
					return (
						<div
							className="flex flex-col text-center items-center relative cursor-pointer "
							key={item.id}
						>
							<div
								className={
									'p-2 border text-text-paragraph rounded-md border-custom-border font-bahnschrift text-xs items-center justify-center flex' +
									(filters === item.id
										? ' bg-primary text-white'
										: ' bg-surface-action-secondary text-text-paragraph')
								}
								onClick={(e) => {
									e.stopPropagation();
									e.preventDefault();
									setFilters(item.id);
									SetTournamentGroup(item);
								}}
							>
								{verifyDatePick(
									item.entryEventAt.replace('Z', '')
								)}{' '}
								{item.title}{' '}
								<TooltipGames
									icon={
										<RiCalendarEventFill className="w-4 h-4 ml-2" />
									}
									title="Eventos"
									events={item.events}
								/>
							</div>
						</div>
					);
				})
			)}
		</div>
	);
};
